import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SectionHeading from "@/components/SectionHeading";
import Gallery from "@/components/Gallery";
import HeroSection from "@/components/HeroSection";

const OkenskePolice = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection
          title="Okenske police"
          subtitle="Okenske police iz naravnega kamna"
          imageSrc="/placeholder.svg"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />
        
        <div className="container-custom mx-auto py-16">
          <SectionHeading
            title="Okenske police"
            subtitle="Okenske police iz naravnega kamna"
          />
          
          <div className="mt-8 prose prose-lg max-w-none">
            <p>
              Okenske police iz naravnega kamna so eleganten in praktičen dodatek vsakemu prostoru.
              Odlikuje jih dolga življenjska doba, odpornost na vlago in preprosto vzdrževanje.
            </p>
          </div>
          
          <Gallery
            images={[
              { src: "/placeholder.svg", alt: "Okenske police 1" },
              { src: "/placeholder.svg", alt: "Okenske police 2" },
              { src: "/placeholder.svg", alt: "Okenske police 3" },
              { src: "/placeholder.svg", alt: "Okenske police 4" },
            ]}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default OkenskePolice;